import React from 'react'
import {FC} from 'react'
import {CellPropsType} from './cellPropsType'
import {useSelector} from 'react-redux'
import {select_databaseOptions} from 'redux/jobRequests/selectors'

const DatabaseName: FC<CellPropsType> = ({cell}) => {
  const databaseOptions = useSelector(select_databaseOptions)

  const value = cell.getValue()
  const db = databaseOptions.find(sg => {
    return sg.databaseId === value
  })

  const dbName = db?.hostname
  return (
    <div>
      {dbName ?? ''}
    </div>
  )
}

export default DatabaseName
